<div [ngClass]="getClassNames('switchRow')">

  <ng-container *ngIf="getButtonGroupTemplate() as template; else defaultButtonGroup">
    <div [ngClass]="getClassNames('buttonGroup', 'rightAlign')">
      <ng-container *ngTemplateOutlet="template; context: getButtonGroupContext()"></ng-container>
    </div>
  </ng-container>

  <ng-template #defaultButtonGroup>
    <div [ngClass]="getClassNames('buttonGroup', 'rightAlign')" *ngIf="!disabled" class="mr-2">
      <label class="rule-link-label">{{'RULE-LINK-PART-1' | translate }}
        <a title="{{ 'RULE-TITLE' | translate }}" (click)="addRule()">{{'RULE-LINK-PART-2' | translate }}</a>
        <span>&nbsp;{{'RULE-LINK-PART-3' | translate }}&nbsp;</span><a title="{{ 'RULESET-TITLE' | translate }}"
          (click)="addRuleSet()">{{'RULE-LINK-PART-4' | translate }}</a>
      </label>
      <ng-container *ngIf="!!parentValue && allowRuleset && !disabled">
        <div class="ml-2 mr-2" title="{{'REMOVE-RULESET-TITLE'|translate}}" (click)="removeRuleSet()"><i
            class="fas fa-fw fa-times-circle fa-delete-custom"></i></div>
      </ng-container>
    </div>
  </ng-template>

  <ng-container *ngIf="getSwitchGroupTemplate() as template; else defaultSwitchGroup">
    <ng-container *ngTemplateOutlet="template; context: getSwitchGroupContext()"></ng-container>
  </ng-container>

  <ng-template #defaultSwitchGroup>
    <kendo-buttongroup style="margin-left:4px;" [ngClass]="getClassNames('switchGroup', 'transition')"
      [disabled]="disabled" [selection]="'single'" *ngIf="data.rules.length">
      <button kendoButton (click)="changeCondition('or')" [toggleable]="true" [selected]="data.condition==='or'"
        value="or" #orOption>{{ 'RULE-ANY' | translate }}</button>
      <button kendoButton (click)="changeCondition('and')" [toggleable]="true" [selected]="data.condition==='and'"
        value="and" #andOption class="ml-2">{{ 'RULE-ALL' | translate }}</button>
    </kendo-buttongroup>
  </ng-template>
</div>

<ul [ngClass]="getClassNames('tree')" *ngIf="data && data.rules">
  <ng-container *ngFor="let rule of data.rules;let i = index">
    <ng-container
      *ngIf="{ruleset: !!rule.rules, invalid: !config.allowEmptyRulesets && rule.rules && rule.rules.length === 0} as local">
      <!--2021-02-17 PR: Removed too confusing
      <label class="pt-2 ml-2" *ngIf="local.ruleset">{{ 'RULE-AND' | translate }}</label>-->
      <li [ngClass]="getQueryItemClassName(local)">
        <ng-container *ngIf="!local.ruleset">

          <ng-container *ngIf="getRemoveButtonTemplate() as template; else defaultRemoveButton">
            <div [ngClass]="getClassNames('buttonGroup', 'rightAlign')">
              <ng-container *ngTemplateOutlet="template; context: getRemoveButtonContext(rule)"></ng-container>
            </div>
          </ng-container>

          <ng-template #defaultRemoveButton>
            <div *ngIf="!disabled" title="{{'REMOVE-RULE-TITLE'|translate}}" (click)="removeRule(rule, data)"><i
                class="fas fa-fw fa-times-circle fa-delete-custom" style="margin-top:2px"></i></div>
          </ng-template>

          <div *ngIf="entities?.length > 0" class="q-inline-block-display">
            <ng-container *ngIf="getEntityTemplate() as template; else defaultEntity">
              <ng-container *ngTemplateOutlet="template; context: getEntityContext(rule)"></ng-container>
            </ng-container>
          </div>

          <ng-template #defaultEntity>
            <div [ngClass]="getClassNames('entityControlSize')">
              <select [ngClass]="getClassNames('entityControl')" [(ngModel)]="rule.entity"
                (ngModelChange)="changeEntity($event, rule, i, data)" [disabled]="disabled">
                <option *ngFor="let entity of entities" [ngValue]="entity.value">
                  {{entity.name | truncate: selectTruncateSize}}
                </option>
              </select>
            </div>
          </ng-template>

          <ng-container *ngIf="getFieldTemplate() as template; else defaultField">
            <ng-container *ngTemplateOutlet="template; context: getFieldContext(rule)"></ng-container>
          </ng-container>

          <ng-template #defaultField>
            <div [ngClass]="getClassNames('fieldControlSize')">
              <select [ngClass]="getClassNames('fieldControl')" [(ngModel)]="rule.field"
                title="{{getFieldTitle(rule.field)}}" (ngModelChange)="changeField($event, rule)" [disabled]="disabled">
                <option *ngFor="let field of getFields(rule.entity)" [ngValue]="field.value" style="max-width:500px">
                  {{field.name | truncate: selectTruncateSize}}
                </option>
              </select>
            </div>
          </ng-template>

          <ng-container *ngIf="getOperatorTemplate() as template; else defaultOperator">
            <ng-container *ngTemplateOutlet="template; context: getOperatorContext(rule)"></ng-container>
          </ng-container>

          <ng-template #defaultOperator>
            <div [ngClass]="getClassNames('operatorControlSize')">
              <select [ngClass]="getClassNames('operatorControl')" [(ngModel)]="rule.operator"
                (ngModelChange)="changeOperator(rule)" [disabled]="disabled">
                <option *ngFor="let operator of getOperators(rule.field)" [ngValue]="operator">
                  {{getOperatorText(operator)}}
                </option>
              </select>
            </div>
          </ng-template>

          <ng-container *ngIf="findTemplateForRule(rule) as template; else defaultInput">
            <ng-container *ngTemplateOutlet="template; context: getInputContext(rule)"></ng-container>
          </ng-container>

          <ng-template #defaultInput>
            <div *ngIf="!isUpdating" [ngClass]="getClassNames('inputControlSize')"
              [ngSwitch]="getInputType(rule.field, rule.operator)">
              <input [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                [disabled]="disabled" *ngSwitchCase="'String'" type="text">
              <input [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                [disabled]="disabled" *ngSwitchCase="'Number'" type="number">
              <input [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                [disabled]="disabled" *ngSwitchCase="'Date'" type="date">
              <input [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                [disabled]="disabled" *ngSwitchCase="'Time'" type="time">
              <input [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                [disabled]="disabled" *ngSwitchCase="'DateTime'" type="datetime-local" style="min-width: 225px;">
              <select [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                [disabled]="disabled" *ngSwitchCase="'Category'">
                <option *ngFor="let opt of getOptions(rule.field)" [ngValue]="opt.value">
                  {{opt.name | truncate: selectTruncateSize}}
                </option>
              </select>
              <ng-container *ngSwitchCase="'Multiselect'">
                <select [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value"
                  (ngModelChange)="changeInput()" [disabled]="disabled" multiple>
                  <option *ngFor="let opt of getOptions(rule.field)" [ngValue]="opt.value">
                    {{opt.name | truncate: selectTruncateSize}}
                  </option>
                </select>
              </ng-container>
              <input [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                [disabled]="disabled" *ngSwitchCase="'Boolean'" type="checkbox" style="margin-top:14px;" kendoCheckBox>
            </div>
            <label class="custom-label-condition-suffix" *ngIf="(data.rules[i+1]) && data.condition === 'and'">{{
              'RULE-AND' | translate }}</label>
            <label class="custom-label-condition-suffix" *ngIf="(data.rules[i+1]) && data.condition === 'or'">{{
              'RULE-OR' | translate }}</label>
          </ng-template>
        </ng-container>
        <app-query-builder *ngIf="local.ruleset" [data]="rule" [disabled]="disabled"
          [parentTouchedCallback]="parentTouchedCallback || onTouchedCallback"
          [parentChangeCallback]="parentChangeCallback || onChangeCallback"
          [parentInputTemplates]="parentInputTemplates || inputTemplates"
          [parentOperatorTemplate]="parentOperatorTemplate || operatorTemplate"
          [parentFieldTemplate]="parentFieldTemplate || fieldTemplate"
          [parentEntityTemplate]="parentEntityTemplate || entityTemplate"
          [parentSwitchGroupTemplate]="parentSwitchGroupTemplate || switchGroupTemplate"
          [parentButtonGroupTemplate]="parentButtonGroupTemplate || buttonGroupTemplate"
          [parentRemoveButtonTemplate]="parentRemoveButtonTemplate || removeButtonTemplate" [parentValue]="data"
          [classNames]="classNames" [config]="config" [allowRuleset]="allowRuleset" [operatorMap]="operatorMap">
        </app-query-builder>
        <p [ngClass]="getClassNames('emptyWarning')" *ngIf="local.invalid">A ruleset cannot be empty. Please add a rule
          or remove it all together.</p>
      </li>
    </ng-container>
  </ng-container>
</ul>